import React, { useState } from 'react';
import { X, Instagram, Facebook } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import { useTranslation } from 'react-i18next';

const SocialWidget = () => {
  const { isDark } = useTheme();
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  // Social media URLs
  const instagramUrl = 'https://www.instagram.com/okinawasignstudio/';
  const facebookUrl = 'https://facebook.com';

  return (
    <div className="fixed bottom-16 sm:bottom-6 right-4 sm:right-6 z-50 flex flex-col items-center">
      {/* Expanded Panel */}
      {isExpanded && (
        <div 
          className="mb-3 p-4 rounded-xl shadow-2xl animate-in slide-in-from-bottom-2 duration-300"
          style={{
            backgroundColor: isDark ? '#1a1a1a' : '#ffffff',
            border: `2px solid ${isDark ? '#00ffff' : '#00bfff'}`,
            boxShadow: isDark 
              ? '0 0 30px rgba(0, 255, 255, 0.4)' 
              : '0 0 25px rgba(0, 191, 255, 0.3)',
            minWidth: '200px'
          }}
        >
          <button
            onClick={() => setIsExpanded(false)}
            className="absolute top-2 right-2 p-1 rounded-full transition-all duration-300 hover:scale-110"
            style={{
              backgroundColor: isDark ? 'rgba(0, 255, 255, 0.2)' : 'rgba(0, 191, 255, 0.1)',
              color: isDark ? '#00ffff' : '#00bfff'
            }}
          >
            <X className="w-4 h-4" />
          </button>
          
          <h3 
            className="font-bold text-lg mb-3 pr-6"
            style={{ color: isDark ? '#ffffff' : '#0f172a' }}
          >
            {t('widgets.connectWithUs')}
          </h3>
          
          <div className="flex flex-col gap-2">
            <a
              href={instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 py-2 px-3 rounded-lg font-semibold transition-all duration-300 hover:scale-105"
              style={{
                background: 'linear-gradient(135deg, #833AB4 0%, #FD1D1D 50%, #FCAF45 100%)',
                color: '#ffffff',
              }}
            >
              <Instagram className="w-5 h-5" />
              Instagram
            </a>
            <a
              href={facebookUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 py-2 px-3 rounded-lg font-semibold transition-all duration-300 hover:scale-105"
              style={{
                background: '#1877F2',
                color: '#ffffff',
              }}
            >
              <Facebook className="w-5 h-5" />
              Facebook
            </a>
          </div>
        </div>
      )}

      {/* Label above button - centered on all screens */}
      <div 
        className="text-center mb-2 animate-pulse"
        style={{
          color: isDark ? '#ffff00' : '#ff8c00',
          textShadow: isDark 
            ? '0 0 10px rgba(255, 255, 0, 0.6)' 
            : '0 0 8px rgba(255, 140, 0, 0.4)'
        }}
      >
        <span className="text-[9px] sm:text-xs font-bold leading-tight block">{t('widgets.dontKnow')}</span>
        <span className="text-[9px] sm:text-xs font-bold leading-tight block">{t('widgets.whereToStart')}</span>
        <span className="text-[10px] sm:text-sm font-bold tracking-wider block mt-1">{t('widgets.messageUsNow')}</span>
      </div>

      {/* Floating Button */}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="flex items-center justify-center gap-2 px-4 py-3 rounded-full font-semibold transition-all duration-300 hover:scale-110 shadow-lg"
        style={{
          background: isDark 
            ? 'linear-gradient(135deg, #00ffff 0%, #00ff88 100%)'
            : 'linear-gradient(135deg, #00bfff 0%, #10b981 100%)',
          color: isDark ? '#000000' : '#ffffff',
          boxShadow: isDark 
            ? '0 6px 30px rgba(0, 255, 255, 0.5)' 
            : '0 6px 25px rgba(0, 191, 255, 0.4)'
        }}
      >
        <Instagram className="w-5 h-5" />
        <Facebook className="w-5 h-5" />
        <span className="hidden sm:inline">{t('widgets.social')}</span>
      </button>
    </div>
  );
};

export default SocialWidget;
